var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { View } from 'react-native';
import { BLACK_700 } from '../../../../constants';
import { getTestId } from '../../../../utils';
import { Typography } from '../../../typography';
import { getLinearProgressStyles, getLinearProgressTypography } from './LinearProgressStyles';
var LinearProgress = forwardRef((props, ref) => {
  var linearProgressStyles = getLinearProgressStyles(props);
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'LinearProgress' : _props$testID,
    size = props.size,
    startText = props.startText,
    endText = props.endText,
    hintText = props.hintText,
    style = props.style,
    restProps = __rest(props, ["testID", "size", "startText", "endText", "hintText", "style"]);
  return _jsxs(View, Object.assign({
    ref: ref,
    style: style
  }, restProps, getTestId(testID), {
    children: [!!(startText || endText) && _jsxs(View, Object.assign({
      style: linearProgressStyles.startEndContainer
    }, {
      children: [!!startText && _jsx(Typography, {
        color: BLACK_700,
        type: getLinearProgressTypography(size).start,
        text: startText,
        style: linearProgressStyles.startText
      }), !!endText && _jsx(Typography, {
        type: getLinearProgressTypography(size).end,
        text: endText
      })]
    })), _jsx(View, Object.assign({
      style: linearProgressStyles.barContainer
    }, {
      children: _jsx(View, Object.assign({
        style: linearProgressStyles.bar
      }, getTestId(testID, 'value')))
    })), !!hintText && _jsx(Typography, Object.assign({
      color: BLACK_700,
      type: getLinearProgressTypography(size).hint,
      text: hintText,
      style: linearProgressStyles.hintText
    }, getTestId(testID, 'hintText')))]
  }));
});
export default LinearProgress;